import { Component } from 'preact'
import Header from '../../header'
import AlertComponent from '../../ui-components/AlertComponent'
import InputGroup from '../../ui-components/InputGroup'
import Attachments from '../../category/control/Attachments'
import DynamicSaveBar from '../../ui-components/DynamicSaveBar'
import axios from 'axios'
import ConfirmationModal from '../../ui-components/ConfirmationModal'

class KnowledgeBaseParentCategoryEdit extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      message: null,
      errors: [],
      category: props.category,
      savedCategory: props.category,
      showModal: false,
      showConfirmation: false,
      successMessage: '',
      isLoading: false
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.resetChanges = this.resetChanges.bind(this)
    this.setValue = this.setValue.bind(this)
    this.hasChanged = this.hasChanged.bind(this)
    this.deleteCategory = this.deleteCategory.bind(this)
    this.canBeDeleted = this.canBeDeleted.bind(this)
    this.getDeleteConfirmationTitle = this.getDeleteConfirmationTitle.bind(this)
    this.getDeleteConfirmationText = this.getDeleteConfirmationText.bind(this)
    this.getDeleteConfirmationButtons = this.getDeleteConfirmationButtons.bind(this)
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this)
  }

  showMessage (messageType, message) {
    this.setState({ messageType, message, showConfirmation: false, isLoading: false }, () => {
      window.setTimeout(() => this.setState({ messageType: null, message: null }), 5000)
    })
  }

  saveCategory () {
    const newData = JSON.parse(JSON.stringify(this.state.category))
    let errors = []

    if (!newData.title || newData.title === '') {
      errors.push('title')
    }
    if (!newData.description || newData.description === '') {
      errors.push('description')
    }
    if (errors.length) {
      this.setState({ errors })
      return
    }

    this.setState({ isLoading: true })

    axios.post('/platform/knowledge-base/new', newData, { params: { id: this.state.category.id } })
      .then(() => {
        this.setState({ messageType: 'success', isLoading: false, savedCategory: this.state.category }, () => {
          window.setTimeout(() => this.setState({ messageType: null }), 5000)
        })
      })
      .catch(() => {
        this.setState({ messageType: 'error', isLoading: false }, () => {
          window.setTimeout(() => this.setState({ messageType: null }), 5000)
        })
      })
  }

  resetChanges () {
    this.setState({ category: this.state.savedCategory })
  }

  setValue (key, value) {
    const category = Object.assign({}, this.state.category, { [key]: value })
    this.setState({ category, errors: [] })
  }

  hasChanged () {
    return JSON.stringify(this.state.savedCategory) !== JSON.stringify(this.state.category)
  }

  componentDidMount () {
    if (this.props.showSuccess) {
      this.showMessage('success', 'New parent category is added successfully!')
    }

    window.onbeforeunload = (e) => {
      if (!this.hasChanged()) return
      e.preventDefault()
      e.returnValue = ''
    }
  }

  deleteCategory () {
    this.setState({ isLoading: true })
    axios.delete('/platform/knowledge-base/edit', { params: { id: this.state.category.id } })
      .then(() => {
        this.setState({ messageType: 'success', isLoading: false, savedCategory: this.state.category }, () => {
          window.setTimeout(() => this.setState({ messageType: null }), 5000)
        })
        window.location.assign(this.props.overviewLink)
      })
      .catch(() => {
        this.setState({ messageType: 'error', isLoading: false }, () => {
          window.setTimeout(() => this.setState({ messageType: null }), 5000)
        })
      })
  }

  closeConfirmationDialog () {
    this.setState({ showConfirmation: false })
  }

  canBeDeleted () {
    return this.state.category.visibleSubCategories === 0
  }

  getDeleteConfirmationTitle () {
    if (this.canBeDeleted()) {
      return `Delete parent category "${this.state.category.title}"`
    }

    return 'Parent category is not empty yet'
  }

  getDeleteConfirmationText () {
    if (this.canBeDeleted()) {
      return "Be careful, once it's deleted, it's gone for good!"
    }

    return <div>
      If you're absolutely sure you want to delete it, you'll need to remove all of its <strong>{this.state.category.visibleSubCategories} categories</strong> by going to <a href={this.props.overviewLink}>Knowledge Base</a>, first.
    </div>
  }

  getDeleteConfirmationButtons () {
    if (!this.canBeDeleted()) {
      return [{
        text: 'Okay',
        callback: this.closeConfirmationDialog,
        class: 'btn btn-primary',
        showLoading: false
      }]
    }
    return [
      {
        text: 'Delete',
        callback: this.deleteCategory,
        class: 'btn btn-danger',
        showLoading: true
      },
      {
        text: 'Cancel',
        callback: this.closeConfirmationDialog,
        class: 'btn btn-default',
        showLoading: false
      }
    ]
  }

  render (props, state) {
    const displaySaveBar = this.hasChanged()

    return (
      <div className='category-container category-edit_container'>
        <Header
          title='Edit parent category'
          disableCancelButton
          disableSaveButton
          hasBreadcrumb
          breadcrumbText='Back to Knowledge Base'
          breadcrumbLink={props.overviewLink}
        />
        <AlertComponent messageType={state.messageType} message={state.message} />
        <form>
          <InputGroup
            title='Title'
            placeholder='Add a title'
            type={'text'}
            error={state.errors.indexOf('title') !== -1 ? 'Please fill in this field' : ''}
            onChange={(e) => this.setValue('title', e.target.value)}
            value={state.category.title} />
          <InputGroup
            title='Description'
            placeholder='Add a description'
            error={state.errors.indexOf('description') !== -1 ? 'Please fill in this field' : ''}
            type={'text'}
            onChange={(e) => this.setValue('description', e.target.value)}
            value={state.category.description} />
          <Attachments
            label='Hero image'
            className='hero-image'
            meta={
              <div>
                <div>Hero image will be shown on top of the category page.</div>
                <div>Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</div>
              </div>
            }
            isAttachmentSelected={state.category.heroImage}
            imageSrc={state.category.heroImage && state.category.heroImage.source_thumb}
            width={2880}
            height={480}
            onUpdate={(data) => this.setValue('heroImage', data)}
          />
          <Attachments
            label='Category card image'
            className='thumbnail-image'
            meta={
              <div>
                <div>Category card image will be shown on category cards on homepage.</div>
                <div>Maximum file size: 5MB. Allowed image types: .jpg, .png. We recommend a minimum of 720*272px</div>
              </div>
            }
            isAttachmentSelected={state.category.thumbnailImage}
            imageSrc={state.category.thumbnailImage && state.category.thumbnailImage.source_thumb}
            width={720}
            height={272}
            onUpdate={(data) => this.setValue('thumbnailImage', data)}
          />
        </form>
        <div className='btn btn-danger btn-delete'
          onClick={() => this.setState({ showConfirmation: true })}>
          Delete Parent Category
        </div>
        <ConfirmationModal
          isLoading={state.isLoading}
          enableModal={state.showConfirmation}
          title={this.getDeleteConfirmationTitle()}
          message={this.getDeleteConfirmationText()}
          buttons={this.getDeleteConfirmationButtons()}
          onClose={this.closeConfirmationDialog}
        />
        {
          displaySaveBar ? <DynamicSaveBar cancelCallback={this.resetChanges} saveCallback={this.saveCategory} /> : null
        }
      </div>
    )
  }
}

export default KnowledgeBaseParentCategoryEdit
